import { LOAD_SEO_DATA } from './types';

export function loadSeoData(path) {

    return {
        type: LOAD_SEO_DATA,
        payload: { path }
    }
}